import React, { useContext }            from 'react'
import { ChatContext }                  from '..'

const ChatAppWindow = (props) => {

    // CONTEXT
    const {
        visisibiltyRoom
    } = useContext(ChatContext)

    return (
        <div className={`'content-right p-0 m-0 container-fluid d-lg-block ' ${visisibiltyRoom}`}>
            <div className='content-wrapper'>
                <div className='content-body bg-white'>
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default ChatAppWindow;